// Shared color-card modal — packs + palettes pages
// Self-contained: builds its own DOM on first call
// window.openColorModal(data) — data: { hex, name, code }
// HSTV fields read from window.SILKheeMetafields[data.code] (Shopify metafields)
// Availability fetched live from /products/{handle}.js

(function () {

  var TEMP_LABELS = { W: 'WARM', C: 'COOL', N: 'NEUTRAL' };
  var EXCLUSIVE_CODES = { '5590': true, '5594': true };
  var overlayEl = null, modalEl = null, currentData = null;

  // ── STYLES ────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('ccm-styles')) return;
    var s = document.createElement('style');
    s.id = 'ccm-styles';
    s.textContent = [
      /* overlay */
      '.ccm-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.40);z-index:9000;',
        'opacity:0;transition:opacity 250ms ease;pointer-events:none;}',
      '.ccm-overlay.is-open{opacity:1;pointer-events:all;}',

      /* modal card */
      '.ccm-modal{position:fixed;top:50%;left:50%;',
        'transform:translate(-50%,-50%) scale(0.95);',
        'z-index:9001;width:92%;max-width:380px;',
        'background:#fff;border-radius:20px;',
        'box-shadow:0 12px 48px rgba(0,0,0,0.16);',
        'overflow:hidden;opacity:0;',
        'max-height:92vh;overflow-y:auto;',
        'transition:opacity 250ms ease,transform 250ms ease;',
        'pointer-events:none;}',
      '.ccm-modal.is-open{opacity:1;',
        'transform:translate(-50%,-50%) scale(1);pointer-events:all;}',

      /* close */
      '.ccm-close{position:absolute;top:16px;right:18px;background:none;border:none;',
        'font-size:18px;color:#bbb;cursor:pointer;line-height:1;padding:4px 6px;z-index:3;',
        'transition:color 0.15s;font-weight:300;}',
      '.ccm-close:hover{color:#444;}',

      /* swatch */
      '.ccm-swatch-wrap{padding:28px 24px 20px;}',
      '.ccm-swatch{width:100%;height:220px;border-radius:14px;display:block;}',

      /* body */
      '.ccm-body{padding:0 28px 32px;text-align:center;}',

      /* name */
      '.ccm-name{font-family:"Courier New",Courier,monospace;font-size:18px;font-weight:700;',
        'letter-spacing:3px;text-transform:uppercase;color:#111;line-height:1.2;}',

      /* code */
      '.ccm-code{font-family:"Courier New",Courier,monospace;font-size:14px;',
        'color:#888;margin-top:6px;letter-spacing:1px;}',

      /* HVST grid */
      '.ccm-hvst{display:grid;grid-template-columns:repeat(4,1fr);',
        'gap:2px 0;margin-top:16px;border:1px solid #f0f0f0;border-radius:8px;overflow:hidden;}',
      '.ccm-hvst-cell{display:flex;flex-direction:column;gap:3px;padding:10px 6px;',
        'border-right:1px solid #f0f0f0;}',
      '.ccm-hvst-cell:last-child{border-right:none;}',
      '.ccm-hvst-label{font-family:"Courier New",Courier,monospace;font-size:9px;',
        'color:#999;letter-spacing:1px;text-transform:uppercase;}',
      '.ccm-hvst-value{font-family:"Courier New",Courier,monospace;font-size:13px;',
        'color:#222;font-weight:700;letter-spacing:0.5px;text-transform:uppercase;}',

      /* hex */
      '.ccm-hex{font-family:"Courier New",Courier,monospace;font-size:11px;',
        'color:#999;margin-top:10px;letter-spacing:2px;}',

      /* divider */
      '.ccm-divider{height:1px;background:#f2f2f2;margin:20px 0;}',

      /* palette button */
      '.ccm-btn-palette{display:block;width:100%;height:52px;background:#111;color:#fff;border:none;',
        'font-family:"Courier New",Courier,monospace;font-size:13px;font-weight:700;',
        'letter-spacing:2px;text-transform:uppercase;border-radius:10px;cursor:pointer;',
        'transition:background 0.2s;}',
      '.ccm-btn-palette:hover:not(:disabled){background:#2a2a2a;}',
      '.ccm-btn-palette:disabled{background:#d8d8d8;color:#fff;cursor:default;}',

      /* cart button */
      '.ccm-btn-cart{display:block;width:100%;height:48px;background:#fff;color:#111;',
        'border:1.5px solid #ddd;font-family:"Courier New",Courier,monospace;font-size:13px;',
        'font-weight:700;letter-spacing:2px;text-transform:uppercase;border-radius:10px;',
        'cursor:pointer;margin-top:10px;transition:background 0.2s,color 0.2s,border-color 0.2s;}',
      '.ccm-btn-cart:hover:not(:disabled){background:#111;color:#fff;border-color:#111;}',
      '.ccm-btn-cart:disabled{border-color:#eee;color:#ccc;cursor:default;font-size:10px;letter-spacing:1px;}'
    ].join('');
    document.head.appendChild(s);
  }

  // ── BUILD DOM (once) ─────────────────────────────────────────────
  function buildModal() {
    if (modalEl) return;
    injectStyles();

    overlayEl = document.createElement('div');
    overlayEl.className = 'ccm-overlay';
    overlayEl.addEventListener('click', closeModal);

    modalEl = document.createElement('div');
    modalEl.className = 'ccm-modal';
    modalEl.setAttribute('role', 'dialog');
    modalEl.setAttribute('aria-modal', 'true');
    modalEl.innerHTML =
      '<button class="ccm-close" aria-label="Close">&times;</button>' +
      '<div class="ccm-swatch-wrap"><div class="ccm-swatch"></div></div>' +
      '<div class="ccm-body">' +
        '<div class="ccm-name"></div>' +
        '<div class="ccm-code"></div>' +
        '<div class="ccm-hvst">' +
          '<div class="ccm-hvst-cell" id="ccm-cell-hue"><span class="ccm-hvst-label">HUE</span><span class="ccm-hvst-value">—</span></div>' +
          '<div class="ccm-hvst-cell" id="ccm-cell-val"><span class="ccm-hvst-label">VAL</span><span class="ccm-hvst-value">—</span></div>' +
          '<div class="ccm-hvst-cell" id="ccm-cell-sat"><span class="ccm-hvst-label">SAT</span><span class="ccm-hvst-value">—</span></div>' +
          '<div class="ccm-hvst-cell" id="ccm-cell-temp"><span class="ccm-hvst-label">TEMP</span><span class="ccm-hvst-value">—</span></div>' +
        '</div>' +
        '<div class="ccm-hex"></div>' +
        '<div class="ccm-divider"></div>' +
        '<button class="ccm-btn-palette">ADD TO MY PALETTE +</button>' +
        '<button class="ccm-btn-cart">ADD SINGLE TO CART</button>' +
      '</div>';

    modalEl.querySelector('.ccm-close').addEventListener('click', closeModal);
    modalEl.querySelector('.ccm-btn-palette').addEventListener('click', handleAddToPalette);
    modalEl.querySelector('.ccm-btn-cart').addEventListener('click', handleAddSingleToCart);

    document.body.appendChild(overlayEl);
    document.body.appendChild(modalEl);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  // ── OPEN / CLOSE ──────────────────────────────────────────────────
  function openModal(data) {
    buildModal();
    currentData = data;

    // HSTV comes exclusively from Shopify metafields — never from data params
    var mf  = (window.SILKheeMetafields && window.SILKheeMetafields[data.code]) || {};
    var hex = mf.hex || data.hex || '#ccc';
    var isExclusive = EXCLUSIVE_CODES[String(data.code)] || false;

    modalEl.querySelector('.ccm-swatch').style.background = hex;
    modalEl.querySelector('.ccm-name').textContent = (data.name || '').toUpperCase();
    modalEl.querySelector('.ccm-code').textContent = data.code || '';
    modalEl.querySelector('.ccm-hex').textContent  = String(hex).toUpperCase();

    function setCell(id, val) {
      var cell = modalEl.querySelector('#' + id + ' .ccm-hvst-value');
      if (cell) cell.textContent = (val !== undefined && val !== null && val !== '') ? String(val) : '—';
    }
    // hue and sat are strings, val is integer, temp shown as WARM/COOL/NEUTRAL
    setCell('ccm-cell-hue',  mf.hue  || '');
    setCell('ccm-cell-val',  mf.val  !== undefined ? mf.val : '');
    setCell('ccm-cell-sat',  mf.sat  || '');
    setCell('ccm-cell-temp', mf.temp ? (TEMP_LABELS[mf.temp] || String(mf.temp).toUpperCase()) : '');

    // Palette button state
    var palBtn = modalEl.querySelector('.ccm-btn-palette');
    var pal    = getPaletteState();
    var isFull = pal.colors.length >= (pal.size || 6);
    var inPal  = pal.colors.some(function (c) { return c.code === data.code; });
    if (isExclusive) {
      palBtn.textContent = 'EXCLUSIVE TO PACK';
      palBtn.disabled    = true;
    } else if (inPal) {
      palBtn.textContent = 'IN PALETTE \u2713';
      palBtn.disabled    = true;
    } else if (isFull) {
      palBtn.textContent = 'PALETTE FULL';
      palBtn.disabled    = true;
    } else {
      palBtn.textContent = 'ADD TO MY PALETTE +';
      palBtn.disabled    = false;
    }

    // Cart button — exclusive or fetch variant
    var cartBtn = modalEl.querySelector('.ccm-btn-cart');
    currentData._variantId = null;

    if (isExclusive) {
      cartBtn.textContent = 'EXCLUSIVE TO PACK \u2014 NOT SOLD SEPARATELY';
      cartBtn.disabled    = true;
    } else {
      cartBtn.textContent = 'CHECKING\u2026';
      cartBtn.disabled    = true;
      var handle = 'silkhee-poly-40wt-5000y-' + String(data.code).toLowerCase();
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var variant = product.variants && product.variants[0];
          if (variant && variant.available) {
            currentData._variantId = variant.id;
            cartBtn.textContent    = 'ADD SINGLE TO CART';
            cartBtn.disabled       = false;
          } else {
            cartBtn.textContent = 'OUT OF STOCK';
            cartBtn.disabled    = true;
          }
        })
        .catch(function () {
          cartBtn.textContent = 'ADD SINGLE TO CART';
          cartBtn.disabled    = false;
        });
    }

    overlayEl.classList.add('is-open');
    modalEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!overlayEl) return;
    overlayEl.classList.remove('is-open');
    modalEl.classList.remove('is-open');
    document.body.style.overflow = '';
    currentData = null;
  }

  // ── PALETTE STATE ─────────────────────────────────────────────────
  function getPaletteState() {
    try {
      var raw = localStorage.getItem('silkhee_palette');
      var s   = raw ? JSON.parse(raw) : {};
      return { size: s.size || 6, colors: s.colors || [] };
    } catch (_) { return { size: 6, colors: [] }; }
  }

  // ── ACTION HANDLERS ───────────────────────────────────────────────
  function handleAddToPalette() {
    if (!currentData) return;
    var palBtn = modalEl.querySelector('.ccm-btn-palette');
    var mf     = (window.SILKheeMetafields && window.SILKheeMetafields[currentData.code]) || {};

    if (typeof window.silkheeAddToPalette === 'function') {
      window.silkheeAddToPalette({
        name:   currentData.name,
        code:   currentData.code,
        hex:    mf.hex || currentData.hex,
        handle: 'silkhee-poly-40wt-5000y-' + String(currentData.code).toLowerCase()
      });
    }

    palBtn.textContent = 'ADDED \u2713';
    palBtn.disabled    = true;
    setTimeout(closeModal, 1200);
  }

  function handleAddSingleToCart() {
    if (!currentData || !currentData.code) return;
    var cartBtn = modalEl.querySelector('.ccm-btn-cart');
    cartBtn.textContent = 'ADDING\u2026';
    cartBtn.disabled    = true;

    function doAdd(variantId) {
      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function () {
          cartBtn.textContent = 'ADDED \u2713';
          if (typeof window.refreshCart === 'function') window.refreshCart();
          setTimeout(closeModal, 1500);
        })
        .catch(function () {
          cartBtn.textContent = 'NOT AVAILABLE';
          cartBtn.disabled    = false;
          setTimeout(function () { cartBtn.textContent = 'ADD SINGLE TO CART'; }, 2500);
        });
    }

    // Use cached variant id if we already fetched it during openModal
    if (currentData._variantId) {
      doAdd(currentData._variantId);
      return;
    }

    // Fallback: fetch variant id now (shouldn't normally reach here)
    var handle = 'silkhee-poly-40wt-5000y-' + String(currentData.code).toLowerCase();
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = product.variants && product.variants[0];
        if (!variant || !variant.available) throw new Error('unavailable');
        doAdd(variant.id);
      })
      .catch(function () {
        cartBtn.textContent = 'OUT OF STOCK';
        cartBtn.disabled    = true;
      });
  }

  // ── EXPORT ────────────────────────────────────────────────────────
  window.openColorModal = openModal;

})();
